/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

export default class ImageConfig extends Phase.Config {
	constructor(name, mode) {
		super();
		this._name = name;
		this._mode = mode;
	}
	run(opts) {
		opts[`${this._name}_opts`].mode = this._mode;
	}
}
